import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=2806f232&scoped=true&"
import script from "./Step.vue?vue&type=script&lang=ts&"
export * from "./Step.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2806f232",
  null
  
)

export default component.exports